module.exports = "/assets/site/images/sum_janos_portfolio.jpg?797b999d1cd0d1315c81340d394f7c2c";